module.exports = __webpack_public_path__ + "img/avatar.901f470e.png";